import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/rentApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("rent_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("rent_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const persist = (data) => {
    localStorage.setItem("rent_token", data.token);
    setUser(data.user);
    setLoading(false);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return persist(data);
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return persist(data);
  };
  const googleAuth = async (session_id) => {
    const { data } = await api.post("/auth/google", { session_id });
    return persist(data);
  };
  const logout = () => {
    localStorage.removeItem("rent_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleAuth, logout, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
